const normalizeBaseUrl = (value) => value.replace(/\/+$/, "");
const DEFAULT_RENDER_API_URL = "https://swimfantasyapp.onrender.com";

const isValidConfiguredApiBaseUrl = (value) => {
  if (!value) {
    return false;
  }

  const normalized = value.trim();
  const lower = normalized.toLowerCase();

  if (
    normalized.includes("<") ||
    normalized.includes(">") ||
    lower.includes("your-render-service-name")
  ) {
    return false;
  }

  try {
    const parsed = new URL(normalized);
    return parsed.protocol === "http:" || parsed.protocol === "https:";
  } catch {
    return false;
  }
};

const resolveApiBaseUrl = () => {
  const configured = (process.env.REACT_APP_API_BASE_URL || "").trim();
  if (isValidConfiguredApiBaseUrl(configured)) {
    return normalizeBaseUrl(configured);
  }

  if (typeof window !== "undefined") {
    if (process.env.NODE_ENV === "development") {
      return "";
    }

    return "/api";
  }

  return DEFAULT_RENDER_API_URL;
};

export const API_BASE_URL = resolveApiBaseUrl();
